export default __webpack_public_path__ + "static/media/Gloves of Vengeful Zeal.f1489f49.jpg";